import { render, staticRenderFns } from "./vesselProfile.vue?vue&type=template&id=59453653&scoped=true"
import script from "./vesselProfile.vue?vue&type=script&lang=ts"
export * from "./vesselProfile.vue?vue&type=script&lang=ts"
import style0 from "./vesselProfile.vue?vue&type=style&index=0&id=59453653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59453653",
  null
  
)

export default component.exports